import { useAlerts } from '../context/AlertContext';
import { Button } from './ui/button';
import { AlertTriangle, Bell, BellOff, X } from 'lucide-react';

export function CriticalAlertBanner() {
  const { 
    criticalAlerts, 
    isAlertMode, 
    audioEnabled, 
    enableAudio, 
    acknowledgeAlert 
  } = useAlerts();

  if (!isAlertMode || criticalAlerts.length === 0) {
    return null;
  }

  const latestAlert = criticalAlerts[0];

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[100] bg-red-600 text-white shadow-lg animate-pulse-slow"
      data-testid="critical-alert-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/20 rounded-full">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <div>
              <p className="font-bold text-sm">
                CRITICAL ALERT ({criticalAlerts.length})
              </p>
              <p className="text-xs text-red-100">
                {latestAlert.message || `New ${latestAlert.type} requires immediate attention`}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {!audioEnabled && (
              <Button
                size="sm"
                variant="ghost"
                className="text-white hover:bg-white/20"
                onClick={enableAudio}
                data-testid="enable-audio-btn"
              >
                <BellOff className="h-4 w-4 mr-1" />
                Enable Sound
              </Button>
            )}
            {audioEnabled && (
              <span className="text-xs text-red-200 flex items-center gap-1">
                <Bell className="h-3 w-3 animate-bounce" />
                Alarm Active
              </span>
            )}
            <Button
              size="sm"
              variant="secondary"
              onClick={() => acknowledgeAlert(latestAlert.id, latestAlert.type)}
              data-testid="acknowledge-alert-btn"
            >
              <X className="h-4 w-4 mr-1" />
              Acknowledge
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CriticalAlertBanner;
